const handleResponse = (response) => {
  if (!response.ok) {
    return response.json().then((data) => {
      throw new Error(data.error || 'Request failed');
    });
  }
  return response.json();
};

export const getDueQuestionnaireResponses = () =>
  fetch('/api/v2/questionnaire_responses', {
    headers: { 'Content-Type': 'application/json' },
  }).then(handleResponse);

export const getQuestionnaireResponse = (uuid) =>
  fetch(`/api/v2/questionnaire_responses/${uuid}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then(handleResponse);

export const answerQuestionnaireResponse = (uuid, questionId, value) =>
  fetch(`/api/v2/questionnaire_responses/${uuid}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'PUT',
    body: JSON.stringify({ question_id: questionId, value }),
  }).then(handleResponse);

export const createDocusealSubmission = (uuid, questionId) =>
  fetch(`/api/v2/questionnaire_responses/${uuid}/docuseal_submission`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ question_id: questionId }),
  }).then(handleResponse);

export const getDocusealSigningState = (uuid, questionId) =>
  fetch(`/api/v2/questionnaire_responses/${uuid}/docuseal_signing_state?question_id=${questionId}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then(handleResponse);

export const redoDocusealConsent = (uuid, questionId) =>
  fetch(`/api/v2/questionnaire_responses/${uuid}/redo_docuseal_consent`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ question_id: questionId }),
  }).then(handleResponse);

export const searchSites = (uuid, query) =>
  fetch(`/api/v2/questionnaire_responses/${uuid}/site_lookup?q=${encodeURIComponent(query)}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then(handleResponse);
